[
  {
    "position": "Autonomy Engineer",
    "employer": "AeroVect",
    "startDate": "Jan 3rd 2025",
    "endDate": "Oct 5th 2025",
    "description": [
      "Currently Employed"
    ]
  },
  {
    "position": "Robotics Firmware Developer",
    "employer": "Deep Trekker Inc.",
    "startDate": "May 1st 2024",
    "endDate": "Aug 31st 2024",
    "description": [
      "Internship"
    ]
  },
  {
    "position": "Linux Developer",
    "employer": "Wind River",
    "startDate": "Jan 10th 2023",
    "endDate": "Dec 15th 2023",
    "description": [
      "Internship"
    ]
  },
  {
    "position": "Software Developer, Special Projects",
    "employer": "Enzuzo Inc.",
    "startDate": "Jun 5th 2022",
    "endDate": "Sep 20th 2022",
    "description": [
      "Internship"
    ]
  }
]